import DefaultIcon from '@material-ui/icons/ViewList'
import { createElement } from 'react'
import { getResources, Menu, MenuItemLink } from 'react-admin'
import { useSelector } from 'react-redux'

const CustomMenu = (props: any) => {
  const { onMenuClick } = props
  const resources = useSelector(getResources)

  return (
    <Menu {...props}>
      {resources
        .filter((r) => r.options && r.options.hide !== true)
        .map((resource: { name: string | number | null | undefined; options: { label: any }; icon: any }) => (
          <MenuItemLink
            key={resource.name}
            to={`/${resource.name}`}
            primaryText={(resource.options && resource.options.label) || resource.name}
            leftIcon={createElement(resource.icon ? resource.icon : DefaultIcon)}
            onClick={onMenuClick}
          />
        ))}
    </Menu>
  )
}

export default CustomMenu
